<template>
  <div class="loginContainer">
    <br/>
    <h5 class="pageTitle">Connexion membre</h5>
    <br/>

    <login-form v-on:LoginFormValid="loginValidated">
      <template slot="errors">
        <template v-if="errorsBackend.length > 0">
          <span v-for="error in errorsBackend" class="error">
            <template v-if="error[0].messages[0].message === 'Identifier or password invalid.'">
              Mauvais utilisateur ou mot de passe. Veuillez réessayer.
            </template>
            <template v-else>
              Une erreur inconnue s'est produite.
            </template>
          </span>
        </template>
      </template>
    </login-form>

    <button
        class="btn btn-link forgotPassword btn-full-width"
        @click="_forgotPassword"
        style="color: gray; font-size: 12px;"
    >
      J'ai oublié mon mot de passe
    </button>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import loginForm from '../../components/Connexion/Connexion_Formulaire';
  import ForgotPasswordForm from '@/components/Connexion/Connexion_Oublie_Mot_de_passe';

  export default {
    data() {
      return {
        errorsBackend: []
      };
    },
    components: { loginForm },
    computed: {
      ...mapState('account', [ 'status' ])
    },
    created() {
      // reset login status
      this.logout();
    },
    methods: {
      ...mapActions('account', [ 'login', 'logout' ]),

      /**
       * Login quand formulaire validé
       * @param data
       */
      loginValidated(data) {
        const self = this;
        this.errorsBackend = [];
        this.login(data)
          .then(success => {
            self.$router.push({ name: 'MembersPage' });
          })
          .catch(error => {
            self.errorsBackend.push(error);
          });
      },

      _forgotPassword() {
        this.$modal.show(ForgotPasswordForm, {}, {
          height: 'auto',
          minHeight: 300,
          name: 'forgot-password',
          root: this.$root
        });
      }

    }
  };
</script>

<style scoped>
.loginContainer {
  margin-top: auto;
  margin-bottom: auto;
  height: 100%;
  max-width: 415px;
  margin-left: auto;
  margin-right: auto;
}

.error {
  color: #dc3545;
}
</style>
